import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import {FONT_PROXIMA_16} from 'styles/FontConstants';
import {NEAR_BLACK} from 'ui-library/Colors';
import Spinner from 'ui-library/Spinner';

import DataViewContext, {useDataViewContext} from './DataViewContext';
import DataViewPane from './DataViewPane';

/**
 * Render view showing that data is loading.
 *
 * @package
 */
export default function LoadingView(): JSX.Element {
  const dataViewContextValue = useDataViewContext();
  const newDataViewContextValue = useMemo(
    () => ({
      ...dataViewContextValue,
      dataTestAttrs: {component: 'LoadingView', element: 'root'},
    }),
    [dataViewContextValue]
  );
  return (
    <DataViewContext.Provider value={newDataViewContextValue}>
      <DataViewPane>
        <div className={css(styles.loadingViewWrapper)}>
          <Spinner />
          <p className={css(styles.titleText)}>Loading data</p>
        </div>
      </DataViewPane>
    </DataViewContext.Provider>
  );
}

const styles = StyleSheet.create({
  loadingViewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  titleText: {
    ...FONT_PROXIMA_16,
    color: NEAR_BLACK,
  },
});
